__turbopack_context__.v({
  "panelLeft": "DeliveryLeftPanel-module__JyyMdW__panelLeft",
});
